import AlexStates from 'a/components/GameHeader/AlexStates';

import { ACTIVITY_WINDOW_TYPE, GAME_ID, LEVEL_STAGE } from '../data/constants';

const initialState = {
  alexState: AlexStates.INACTIVE,
  sounds: [],
  playing: false,
};

/**
 * Controls sounds, including playing, stopping, and setting Alex.
 * Works by keeping an array of sounds. New sounds are pushed in,
 * and as long as one of them is tagged as VO (unmask_###), Alex will talk.
 *
 * Quick Refs:
 * PLAY_SOUND
 * SOUND_END
 * STOP_SOUND
 * SET_ALEX_STATE
 */
const soundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  const sounds = state.sounds.slice();
  const soundDescs = sounds.map(sound => sound.desc);

  const isAlexActive =
    state.windowType !== ACTIVITY_WINDOW_TYPE.LEVEL ||
    state.stage === LEVEL_STAGE.ONBOARDING;

  switch (action.type) {
    case 'SOUND_PLAYED':
      sounds.push(action.audio);

      for (let i = 0; i < sounds.length; ++i) {
        if (sounds[i].desc.includes('unmask_0')) {
          return {
            alexState: AlexStates.SPEAKING,
            sounds,
            playing: true,
          };
        }
      }

      return {
        alexState: isAlexActive ? AlexStates.ACTIVE : AlexStates.INACTIVE,
        sounds,
        playing: true,
      };
    case 'SOUND_ENDED':
      if (soundDescs.indexOf(action.description) !== -1) {
        sounds.splice(soundDescs.indexOf(action.description), 1);

        if (sounds.length === 0) {
          return {
            alexState: action.alexActive ? AlexStates.ACTIVE : AlexStates.INACTIVE,
            sounds,
            playing: false,
          };
        }
      }

      return {
        ...state,
        sounds,
        playing: true,
      };
    case 'SOUND_STOPPED':
      return {
        alexState:
          state.stage === LEVEL_STAGE.ONBOARDING
            ? AlexStates.ACTIVE
            : AlexStates.INACTIVE,
        sounds: [],
        playing: false,
      };
    case 'SET_ALEX_STATE':
      return {
        ...state,
        alexState: action.alexState,
      };
    default:
      return state;
  }
};

export default soundReducer;
